import axios from "axios";
import { getToken } from "../auth/authService";

function authHeaders() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const searchProcessLogs = (params) =>
  axios
    .get("/dashboard/process-logs", { params, headers: authHeaders() })
    .then((r) => r.data);
